// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__24Ct7","image":"Header_image__27uCc","name":"Header_name__2iaEd","info":"Header_info__2Smkc","infoRow":"Header_infoRow__1v5Gj"};